<template>
    <div class="flex-grow-1 primary-lighter3 pt-2 pb-4 px-4" style="flex: 1">
        <b class="text-overline font-weight-bold black--text">
            <slot name="title"> </slot
        ></b>
        <slot></slot>
    </div>
</template>

<script>
import GlobalMixins from "@/mixins/global";

export default {
    mixins: [GlobalMixins],
    name: "blocks",
};
</script>
